const makeRequest = async (messages, conversationId, language, safeguardingCID) => {
  const response = await fetch('/admin/config/services/chatbot/api', {
    method: 'POST',
    body: JSON.stringify({
      messages: messages,
      conversationID: conversationId,
      safeguardingCID: safeguardingCID,
      language: language
    })
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw Error(errorData.message);
  }

  var data = await response.json();

  return data;
};

export const getGreeting = async (conversationId, language) => {
  return await makeRequest([
    { content: 'Greet the user, and ask what you can do for them.', role: 'user', skipTranslate: true }
  ], conversationId, language, '');
};

export const getResponse = async (messages, conversationId = '', language, safeguardingCID = '') => {
  return await makeRequest(messages, conversationId, language, safeguardingCID);
};

export function makeConversationID(length) {
  let result = '';
  const characters = '0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}
